import api from "./api";

// ================= READ =================

export const fetchPlatformModules = async () => {
    const res = await api.get("/platform-modules");
    return res.data ?? [];
};

export const getPlatformModule = async (id) => {
    const res = await api.get(`/platform-modules/${id}`);
    return res.data;
};

// ================= CREATE =================

export const createPlatformModule = async (module) => {
    const res = await api.post("/platform-modules", module);
    return res.data;
};

// ================= UPDATE =================

export const updatePlatformModule = async (id, module) => {
    const res = await api.put(`/platform-modules/${id}`, module);
    return res.data;
};

// ================= DELETE =================

export const deletePlatformModule = async (id) => {
    await api.delete(`/platform-modules/${id}`);
};

// ================= ENABLE / DISABLE =================

export const enablePlatformModule = async (id) => {
    const res = await api.patch(`/platform-modules/${id}/enable`);
    return res.data;
};

export const disablePlatformModule = async (id) => {
    const res = await api.patch(`/platform-modules/${id}/disable`);
    return res.data;
};

// ================= VERSION =================

export const updatePlatformModuleVersion = async (id, version) => {
    const res = await api.patch(`/platform-modules/${id}/version`, {
        version,
    });

    return res.data;
};

export default {
    fetchPlatformModules,
    getPlatformModule,
    createPlatformModule,
    updatePlatformModule,
    deletePlatformModule,
    enablePlatformModule,
    disablePlatformModule,
    updatePlatformModuleVersion,
};